import React from 'react'
import IconButton from '@mui/material/IconButton';
import {Icon} from '@mui/material';
import {ShoppingBasketOutlined} from '@mui/icons-material';
import Badge from '@mui/material/Badge';
import {Link} from 'react-router-dom'
import {useSelector} from "react-redux";

export default function ShoppingCart() {
const sizeOfCart = useSelector(state=>state.cart.sizeOfCart);
    return (
        <IconButton style={{padding: 4}} color="inherit" component={Link} to='/Basket' >
            <Badge color='error' badgeContent={sizeOfCart}>
                <Icon><ShoppingBasketOutlined color='secondary'/></Icon>
            </Badge>
        </IconButton>
    )
}
